module.exports = __webpack_public_path__ + "static/img/maptwo.39cc3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maptwo.png
// module id = i5bw
// module chunks = 29